/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
import React, { useState, useEffect, Fragment } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Table, Input, Select } from 'antd';
import { CloseOutlined, EditOutlined, SaveOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import H3FormInput from '@Uilib/h3FormInput';
import H3Text from '@Uilib/h3Text';
import { QUANTITY, DEFAULT_CUR_ROUND_OFF } from '@Apis/constants';
import { v4 as uuidv4 } from 'uuid';
import Helpers from '@Apis/helpers';
import BatchSelectorCN from './BatchSelectorCN';
import SelectTax from '../../../../Admin/Common/SelectTax';
import './style.scss';
import ProductDescriptions from '@Components/Common/ProductDescriptions';
import '../../../Invoice/InvoiceForm/InvoiceLines/style.scss';
import ProductFilterV2 from '@Components/Common/ProductFilterV2';
import ProductCategoryLabel from '../../../../Common/ProductCategoryLabel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTag, faClose } from '@fortawesome/free-solid-svg-icons';
import QuickAddButton from '@Components/Common/UILib/QuickAddButton';
import PRZSelect from '../../../../Common/UI/PRZSelect';
import CustomFieldHelpers from '../../../../../helpers/CustomFieldHelpers';

const CNLines = (props) => {
  const {
    data, loading, user, toggleBatch, updateData, title, handleProductChangeValue, handleProductChange, cnWithoutDeductingStock, formSubmitted, billFromState, billToState, selectedCurrencyName, MONEY, isLineWiseDiscount, handleDelete, creditNoteWithReturnedQyt, selectedInvoice, addNewRow, tenantDepartmentId, creditNoteWithoutLines, isAdhocCnLiens, priceMasking, discountPercentage, discountType, isReturnSlip, visibleColumns, customLineInputChange, isCarryForward, cfCreditNoteLine,
  } = props;

  const [isEditing, setIsEditing] = useState(true);

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleSave = () => {
    setIsEditing(false);
  };

  const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;

  const amountTypeOptions = [
    {
      label: `${selectedCurrencyName?.currency_symbol} `,
      value: 'Amount',
    },
    {
      label: '%',
      value: 'Percent',
    },
  ];

  const getColumns = () => {
    const columns = [
      {
        title: creditNoteWithoutLines ? 'Product/Reason' : 'Product',
        width: '200px',
        fixed: 'left',
        render: (text, record) => (
          <React.Fragment>
            {selectedInvoice ? (
              <div className="invoice-table__product-name">
                <Link to={`/inventory/product/view/${record?.product_sku_info?.product_sku_id}`} target="_blank">
                  {`#${record?.product_sku_info?.internal_sku_code} `}
                </Link>
                <div>{record.product_sku_name}</div>
                <div style={{ display: 'flex' }}>
                  <div style={{ marginTop: '2px' }}>
                    {record?.product_sku_info?.product_type === 'BUNDLE' && (
                      <H3Text text="Bundle" className="table-subscript table-subscript-tag" />
                    )}
                    {record?.product_sku_info?.product_type === 'SERVICE' && (
                      <H3Text text="Service" className="table-subscript table-subscript-tag" />
                    )}
                    {!['SERVICE', 'BUNDLE'].includes(record?.product_sku_info?.product_type) && (
                      <H3Text text="Goods" className="table-subscript table-subscript-tag" />
                    )}
                  </div>
                </div>
              </div>
            ) : (creditNoteWithoutLines ? (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {isEditing ? (
                  <Input
                    value={record?.product_sku_name}
                    onChange={(event) => {
                      const copyData = JSON.parse(JSON.stringify(data));
                      const updatedData = copyData.map((obj) => {
                        if (obj.key === record.key) {
                          return {
                            ...obj,
                            product_sku_name: event.target.value,
                          };
                        }
                        return obj;
                      });
                      updateData(updatedData);
                    }}
                    style={{
                      marginRight: 8,
                      height: '30px',
                      width: '100%',
                      borderRadius: '2px',
                      border: '1px solid rgba(68, 130, 218, 0.2)',
                      padding: '10px 8px',
                      fontSize: '13px',
                    }}
                  />
                ) : (
                  <div style={{ marginRight: 8 }}>
                    {record?.product_sku_name}

                  </div>
                )}
                {isEditing ? (
                  <SaveOutlined onClick={handleSave} style={{ cursor: 'pointer', color: 'green' }} />
                ) : (
                  <EditOutlined onClick={handleEdit} style={{ cursor: 'pointer', color: 'blue' }} />
                )}
              </div>
            ) : (
              <React.Fragment>
                <ProductFilterV2
                  record={record}
                  productTypes={['STORABLE', 'SERVICE', 'NON_STORABLE']}
                  handleProductChangeValue={handleProductChangeValue}
                  handleProductChange={handleProductChange}
                  isPurchaseProduct
                  required
                  pendingFromVendor
                  showError={formSubmitted && !record.product_sku_name}
                  onClear={(key) => {
                    const copyData = JSON.parse(JSON.stringify(data));
                    const updatedData = copyData.map((item) => {
                      if (item.key === key) {
                        return {
                          key: uuidv4(),
                          asset1: '',
                          product_sku_name: '',
                          quantity: '',
                          unitPrice: '',
                          lot: 0,
                          taxId: 0,
                          discount: 0,
                          child_taxes: [{
                            tax_amount: 0,
                            tax_type_name: '',
                          }],
                          lineCustomFields: [],
                        };
                      }
                      return item;
                    });
                    updateData(updatedData);
                  }}
                  disabled={!!record?.product_sku_id}
                  excludedProducts={data?.map((item) => item?.tenant_product_id) || []}
                  selectedTenant={user?.tenant_info?.tenants_id}
                  tenantDepartmentId={tenantDepartmentId}
                  showClear
                />
              </React.Fragment>
            ))}
            {record?.product_category_info?.category_path?.length > 0 && (
              <ProductCategoryLabel
                categoryPath={record?.product_category_info?.category_path}
                categoryName={record?.product_category_info?.category_path?.at(-1)}
                containerStyle={{
                  width: 'fit-content',
                }}
              />
            )}
            {record?.remarkRequired ? (
              <ProductDescriptions
                descriptions={record?.remarks}
                modules={{
                  toolbar: false,
                }}
                onChange={(e) => {
                  const copyData = JSON.parse(JSON.stringify(data));
                  copyData.map((item) => {
                    if (item.key === record.key) {
                      item.remarks = e;
                      item.remarkRequired = !!e?.replace(/<[^>]+>/g, '');
                    }
                    return data;
                  });
                  updateData(copyData);
                }}
                className="invoice-table__remarks"
                placeholder="Add description of this item.."
                key={record.key}
              />
            ) : ''}
            <div className="invoice-table__hsn">
              <H3Text
                text={record?.product_sku_info?.product_type === 'SERVICE' ? 'SAC Code' : 'HSN Code'}
                className="invoice-table__hsn-label"
              />
              <div className="invoice-table__hsn-value">
                <input
                  value={record.hsn_code}
                  onChange={(e) => {
                    const copyData = JSON.parse(JSON.stringify(data));
                    copyData.forEach((item) => {
                      if (item.key === record.key) {
                        item.hsn_code = e.target.value;
                      }
                    });
                    updateData(copyData);
                  }}
                  className="invoice-table__remarks"
                  maxLength="10"
                />
              </div>
            </div>
          </React.Fragment>
        ),
        visible: visibleColumns?.PRODUCT?.visible,
      },
      {
        title: `${isReturnSlip ? 'Consumed Qty' : 'Invoiced Qty'}`,
        render: (text, record) => {
          const consumedQty = Helpers.getValueTotalInObject(record?.product_batches?.filter((item) => item?.batch_in_use), 'consumed_qty');
          return (
            <Fragment>
              {record?.product_sku_info?.product_type?.toUpperCase() === 'SERVICE' ? '-' : (
                <Fragment>
                  {`${record?.invoice_qty || 0} ${record?.uom_info?.uqc?.toProperCase() || ''} `}
                  {Helpers.getValueTotalInObject(record?.product_batches?.filter((item) => item?.batch_in_use), 'consumed_qty') ? (
                    <Fragment>
                      <div className="table-subscript">
                        {`${record.product_sku_name && (consumedQty ? `${QUANTITY(consumedQty || 0, record?.uom_info?.precision)} ${record?.uom_info?.uqc?.toProperCase()}` : <span style={{ color: 'red', fontSize: '11px', whiteSpace: 'nowrap' }}>-</span>)} Selected`}
                      </div>
                      <H3Text
                        text={`In ${record?.product_batches?.filter((item) => item?.batch_in_use)?.length || '0'} Batches`}
                        className="table-subscript"
                      />
                    </Fragment>
                  ) : ''}
                </Fragment>
              )}
            </Fragment>
          );
        },
        hidden: !selectedInvoice,
        visible: selectedInvoice,
      },
      {
        title: 'Returned',
        render: (record) => `${record?.returned_qty || 0} ${record?.uom_info?.uqc?.toProperCase() || ''} `,
        hidden: !selectedInvoice,
        visible: selectedInvoice,
      },
      {
        title: 'Quantity',
        dataIndex: 'quantity',
        width: '150px',
        render: (text, record) => {
          const returnQty = record?.returned_qty;
          const qytValidation = Number(record.quantity) > (Number(record.invoice_qty) - Number(returnQty));
          return (
            <Fragment>
              <div className="cn-quantity-wrapper">
                <H3FormInput
                  value={record.quantity}
                  type="number"
                  containerClassName={`orgInputContainer ${(formSubmitted && Number(record.quantity) <= 0) ? 'create-pr__input' : ''} `}
                  labelClassName="orgFormLabel"
                  inputClassName="orgFormInput"
                  onChange={(event) => {
                    const copyData = JSON.parse(JSON.stringify(data));
                    let discountValue = Number(record?.discount) || 0;
                    const taxableValue = record?.lineDiscountType === 'Percent' ? (event.target.value * record.unitPrice) * (record.discount ? Number(100 - record.discount) / 100 : 1) : Math.max(record?.quantity * record.unitPrice - discountValue, 0);
                    const batches = record?.product_batches;
                    let remainingQty = parseFloat(event.target.value);
                    batches?.forEach((batch) => {
                      // batch.quantity = isReturnSlip ? event.target.value : 0;
                      batch.quantity = 0;
                    });
                    batches?.forEach((batch) => {
                      if (batch?.batch_in_use) {
                        if (remainingQty > 0 && parseFloat(batch.quantity || '0') < Number(batch?.consumed_qty - (batch?.cn_gen_qty || 0))) {
                          batch.quantity = Number(batch?.consumed_qty - (batch?.cn_gen_qty || 0)) > remainingQty ? remainingQty : Number(batch?.consumed_qty - (batch?.cn_gen_qty || 0));
                          remainingQty -= batch.quantity;
                        } else {
                          // batch.quantity = isReturnSlip ? event.target.value : 0;
                          batch.quantity = 0;
                          remainingQty -= batch.quantity;
                        }
                      }
                    });
                    const updatedData = copyData?.map((obj) => {
                      if (obj.key === record.key) {
                        const batchQuantity = (!selectedInvoice && !creditNoteWithReturnedQyt)
                          ? batches?.map((batch) => (batch.batch_in_use ? { ...batch, quantity: event.target.value } : batch))
                          : !creditNoteWithReturnedQyt
                            ? batches?.map((batch) => (batch.batch_in_use ? { ...batch, returned_quantity: batch.quantity } : batch))
                            : batches;
                        return {
                          ...obj,
                          quantity: event.target.value,
                          // returned_quantity: (selectedInvoice && creditNoteWithReturnedQyt) ? event.target.value : obj.returned_quantity,
                          // product_batches: !creditNoteWithReturnedQyt ? batches.map((batch) => ({ ...batch, returned_quantity: batch.quantity })) : batches,
                          product_batches: batchQuantity,
                          child_taxes: Helpers.computeTaxation(taxableValue, record.taxInfo, billFromState, billToState)?.tax_info?.child_taxes,
                          lineCustomFields: record?.lineCustomFields?.map((item) => ({
                            ...item,
                            fieldValue: item?.fieldName === 'Quantity' ? event.target.value : item?.fieldValue,
                          })),
                        };
                      }
                      return obj;
                    });

                    if (!isLineWiseDiscount) {

                      const totalValue = updatedData?.reduce((acc, cur) => acc + (cur?.quantity * cur?.unitPrice), 0);

                      updatedData?.map((item) => {

                        const discountValue = discountType === 'Percent' ? parseFloat(discountPercentage) : ((item?.quantity * item?.unitPrice) / parseFloat(totalValue)) * parseFloat(discountPercentage);
                        const taxableValue = discountType === 'Percent' ? (item?.quantity * item?.unitPrice) * (1 - discountValue / 100) : Math.max(item?.quantity * item?.unitPrice - discountValue, 0);

                        item.discount = discountValue;
                        item.child_taxes = Helpers.computeTaxation(taxableValue, item?.taxInfo, billFromState, billToState)?.tax_info?.child_taxes;
                      });
                    }
                    updateData(updatedData);
                  }}
                />
                <H3Text text={record?.uom_info?.uqc?.toProperCase()} className="cn-quantity-uom" />
              </div>
              {qytValidation && cnWithoutDeductingStock && selectedInvoice ? (
                <H3Text
                  text={`Quantity should be less than or equal to invoiced qty ${Number(record.invoice_qty) - Number(returnQty)} ${record?.uom_info?.uqc?.toProperCase()} `}
                  className="input-error"
                />
              ) : ''}
              {!['SERVICE', 'NON_STORABLE'].includes(record?.product_sku_info?.product_type)
                && !cnWithoutDeductingStock && selectedInvoice
                && Number(record.quantity) > Helpers.getValueTotalInObject(record?.product_batches?.filter((item) => item?.batch_in_use), 'quantity') ? (
                  <H3Text
                    text={`Quantity should be less than ${Helpers.getValueTotalInObject(record?.product_batches?.filter((item) => item?.batch_in_use), 'quantity')} ${record?.uom_info?.uqc?.toProperCase()} `}
                    className="input-error"
                  />
                ) : ''}
            </Fragment>
          );
        },
        hidden: creditNoteWithoutLines,
        visible: !creditNoteWithoutLines,
      },
      // {
      //   title: 'QUANTITY',
      //   dataIndex: 'quantity',
      //   width: '150px',
      //   render: (text, record) => (
      //     <Fragment>
      //       <div className="cn-quantity-wrapper">
      //         <H3FormInput
      //           value={record.quantity}
      //           type="number"
      //           containerClassName={`orgInputContainer ${(formSubmitted && Number(record.quantity) <= 0) ? 'create-pr__input' : ''} `}
      //           labelClassName="orgFormLabel"
      //           inputClassName="orgFormInput"
      //           onChange={(event) => {
      //             const copyData = JSON.parse(JSON.stringify(data));
      //             const updatedData = copyData.map((obj) => {
      //               if (obj.key === record.key) {
      //                 return {
      //                   ...obj,
      //                   quantity: event.target.value,
      //                   child_taxes: Helpers.computeTaxation(event.target.value, record.taxInfo, billFromState, billToState)?.tax_info?.child_taxes,
      //                 };
      //               }
      //               return obj;
      //             });
      //             updateData(updatedData);
      //           }}
      //         />
      //         <H3Text text={record?.uom_info?.uqc?.toProperCase()} className="cn-quantity-uom" />
      //       </div>
      //     </Fragment>
      //   ),
      //   hidden: !creditNoteWithoutLines,
      // },
      {
        title: 'Quantity to be Returned',
        dataIndex: 'quantity',
        width: '150px',
        render: (text, record) => {
          const returnQty = record?.returned_qty;
          const qytValidation = Number(record.returned_quantity) > (Number(record.invoice_qty) - Number(returnQty));
          return (
            <Fragment>
              <div className="cn-quantity-wrapper">
                <H3FormInput
                  value={record.returned_quantity}
                  type="number"
                  containerClassName={`orgInputContainer ${(!isAdhocCnLiens && formSubmitted && Number(record.returned_quantity) > Number(record.quantity)) ? 'create-pr__input' : ''} `}
                  labelClassName="orgFormLabel"
                  inputClassName="orgFormInput"
                  onChange={(event) => {
                    const copyData = JSON.parse(JSON.stringify(data));
                    const taxableValue = (Number(record.quantity) * record.unitPrice) * (record.discount ? Number(100 - record.discount) / 100 : 1);
                    const batches = record?.product_batches;
                    let remainingQty = parseFloat(event.target.value);
                    batches?.forEach((batch) => {
                      batch.returned_quantity = 0;
                    });
                    batches?.forEach((batch) => {
                      if (batch?.batch_in_use) {
                        if (remainingQty > 0 && parseFloat(batch.returned_quantity || '0') < Number(batch?.consumed_qty - (batch?.cn_gen_qty || 0))) {
                          batch.returned_quantity = Number(batch?.consumed_qty - (batch?.cn_gen_qty || 0)) > remainingQty ? remainingQty : Number(batch?.consumed_qty - (batch?.cn_gen_qty || 0));
                          remainingQty -= batch.returned_quantity;
                        } else {
                          batch.returned_quantity = 0;
                          remainingQty -= batch.returned_quantity;
                        }
                      }
                    });
                    const updatedData = copyData?.map((obj) => {
                      if (obj.key === record.key) {
                        const batchQuantity = (!selectedInvoice && creditNoteWithReturnedQyt)
                          ? batches?.map((batch) => (batch.batch_in_use ? { ...batch, returned_quantity: event.target.value, quantity: event.target.value } : batch))
                          : batches;
                        return {
                          ...obj,
                          returned_quantity: event.target.value,
                          product_batches: batchQuantity,
                          child_taxes: Helpers.computeTaxation(taxableValue, record.taxInfo, billFromState, billToState)?.tax_info?.child_taxes,
                        };
                      }
                      return obj;
                    });
                    updateData(updatedData);
                  }}
                />
                <H3Text text={record?.uom_info?.uqc?.toProperCase()} className="cn-quantity-uom" />
              </div>
              {qytValidation && cnWithoutDeductingStock ? (
                <H3Text
                  text={`Quantity should be less than or equal to invoiced qty ${Number(record.invoice_qty) - Number(returnQty)} ${record?.uom_info?.uqc?.toProperCase()} `}
                  className="input-error"
                />
              ) : ''}
              {!['SERVICE', 'NON_STORABLE'].includes(record?.product_sku_info?.product_type)
                && !cnWithoutDeductingStock && selectedInvoice
                && Number(record.returned_quantity) > Helpers.getValueTotalInObject(record?.product_batches?.filter((item) => item?.batch_in_use), 'returned_quantity') ? (
                  <H3Text
                    text={`Quantity should be less than ${Helpers.getValueTotalInObject(record?.product_batches?.filter((item) => item?.batch_in_use), 'returned_quantity')} ${record?.uom_info?.uqc?.toProperCase()} `}
                    className="input-error"
                  />
                ) : ''}
            </Fragment>
          );
        },
        hidden: !creditNoteWithReturnedQyt,
        visible: creditNoteWithReturnedQyt,
      },
      {
        title: 'Unit Price',
        hidden: isReturnSlip,
        render: (text, record) => (
          <div style={{ width: '100px' }}>
            <H3FormInput
              value={record.unitPrice}
              type="number"
              containerClassName={`orgInputContainer ${(formSubmitted && Number(record.unitPrice) <= 0) ? 'create-pr__input' : ''} `}
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              onChange={(e) => {

                const copyData = JSON.parse(JSON.stringify(data));
                const discountValue = Number(record.discount) || 0;
                const taxableValue = record?.lineDiscountType === 'Percent' ? (record.quantity * e.target.value) * (record.discount ? Number(100 - discountValue) / 100 : 1) : Math.max(record.quantity * e.target.value - discountValue, 0);
                copyData.forEach((item) => {
                  if (item.key === record.key) {
                    item.unitPrice = e.target.value;
                    item.child_taxes = Helpers.computeTaxation(taxableValue, record.taxInfo, billFromState, billToState)?.tax_info?.child_taxes;
                  }
                });

                if (!isLineWiseDiscount) {

                  const totalValue = copyData?.reduce((acc, cur) => acc + (cur?.quantity * cur?.unitPrice), 0);

                  copyData?.map((item) => {

                    const discountValue = discountType === 'Percent' ? parseFloat(discountPercentage) : ((item?.quantity * item?.unitPrice) / parseFloat(totalValue)) * parseFloat(discountPercentage);
                    const taxableValue = discountType === 'Percent' ? (item?.quantity * item?.unitPrice) * (1 - discountValue / 100) : Math.max(item?.quantity * item?.unitPrice - discountValue, 0);

                    item.discount = discountValue;
                    item.child_taxes = Helpers.computeTaxation(taxableValue, item?.taxInfo, billFromState, billToState)?.tax_info?.child_taxes;
                  });
                }
                updateData(copyData);
              }}
              hideInput={isDataMaskingPolicyEnable && isHideSellingPrice}
              popOverMessage={'You don\'t have access to view unit price'}
            />
          </div>
        ),
        visible: visibleColumns?.UNIT_PRICE?.visible,
      },
      {
        title: 'Tax',
        hidden: isReturnSlip,
        render: (text, record) => (
          <div style={{ width: '120px' }}>
            <div className="orgInputContainer">
              <SelectTax
                onChange={(value) => {
                  const copyData = JSON.parse(JSON.stringify(data));
                  const discountValue = Number(record.discount) || 0;
                  const taxableValue = record?.lineDiscountType === 'Percent' ? (record.quantity * record.unitPrice) * (discountValue ? Number(100 - discountValue) / 100 : 1) : Math.max(record.quantity * record.unitPrice - discountValue, 0);
                  copyData.forEach((item) => {
                    if (item.key === record.key) {
                      item.taxId = value?.tax_id;
                      item.taxInfo = value;
                      item.child_taxes = Helpers.computeTaxation(taxableValue, value, billFromState, billToState)?.tax_info?.child_taxes;
                    }
                  });
                  updateData(copyData);
                }}
                errorOutline={formSubmitted && !record.taxId}
                selectedGST={record.taxId}
              />
            </div>
          </div>
        ),
        visible: visibleColumns?.TAX?.visible,
      },
      {
        title: 'Discount',
        render: (text, record) => {
          const lineDiscountAmount = record?.lineDiscountType === 'Percent' ? (((record.quantity * record.unitPrice) / 100) * record.discount) : record?.discount;
          const currencySymbol = selectedCurrencyName?.currency_symbol || '';
          return (

            <Fragment>
              <Fragment>
                {isLineWiseDiscount ? (
                  <div style={{ width: '150px', display: 'flex', }}>
                    <H3FormInput
                      value={record.discount}
                      type="number"
                      containerClassName={`orgInputContainer ${(formSubmitted && Number(record.discount) < 0) ? 'create-pr__input' : ''} `}
                      labelClassName="orgFormLabel"
                      inputClassName="orgFormInput"
                      onChange={(e) => {
                        const copyData = JSON.parse(JSON.stringify(data));
                        const discountValue = Number(e.target.value) || 0;
                        const taxableValue = record?.lineDiscountType === 'Percent' ? (record.quantity * record.unitPrice) * (1 - discountValue / 100) : Math.max(record.quantity * record.unitPrice - discountValue, 0);
                        copyData.map((item) => {
                          if (item.key === record.key) {
                            item.discount = e.target.value || '';
                            item.unitDiscount = Number.parseFloat(Number(Number(e.target.value) / Number(record.quantity)).toFixed(DEFAULT_CUR_ROUND_OFF));
                            item.child_taxes = Helpers.computeTaxation(taxableValue, record.taxInfo, billFromState, billToState)?.tax_info?.child_taxes;
                          }
                        });
                        updateData(copyData);
                      }}
                      disabled={!isLineWiseDiscount}
                    />
                    <div className="orgInputContainer discount-type">
                      <PRZSelect
                        value={record?.lineDiscountType}
                        onChange={(value) => {
                          const copyData = JSON.parse(JSON.stringify(data));
                          const discountValue = Number(record.discount) || 0;
                          const taxableValue = value === 'Percent' ? (record.quantity * record.unitPrice) * (1 - discountValue / 100) : Math.max(record.quantity * record.unitPrice - discountValue, 0);

                          copyData.map((item) => {
                            if (item.key === record.key) {
                              item.lineDiscountType = value;
                              item.child_taxes = Helpers.computeTaxation(taxableValue, record.taxInfo, billFromState, billToState)?.tax_info?.child_taxes;
                            }
                            return item;
                          });
                          updateData(copyData);
                        }}
                        style={{
                          width: '50px',
                        }}
                        disabled={!isLineWiseDiscount}
                        options={amountTypeOptions}
                        placeholder=""
                      />
                    </div>
                  </div>
                ) : (
                  <div>
                    <H3Text
                      text={
                        record?.discount ? (record?.lineDiscountType === 'Percent' ? `${(record?.discount)?.toFixed(DEFAULT_CUR_ROUND_OFF)}%` :
                          MONEY((record?.discount)?.toFixed(DEFAULT_CUR_ROUND_OFF), selectedCurrencyName?.currency_code))
                          : (record?.lineDiscountType === 'Percent' ? '0%' : MONEY(0, selectedCurrencyName?.currency_code))
                      }
                    />
                  </div>
                )}
                {(record.quantity > 0 && record.unitPrice > 0 && record.discount > 0) && (
                  <H3Text
                    text={(
                      <div>
                        {record?.lineDiscountType === 'Percent' ? (
                          (isDataMaskingPolicyEnable && isHideCostPrice) ? (
                            <HideValue showPopOver popOverMessage="You don't have access to view discount/unit" />
                          ) : (
                            `${currencySymbol}${(lineDiscountAmount / record?.quantity).toFixed(2)}/unit`
                          )
                        ) : (
                          `${((record?.discount / (record.quantity * record.unitPrice)) * 100).toFixed(2)}% | ${currencySymbol}${(lineDiscountAmount / record?.quantity).toFixed(2)}/unit`
                        )}
                      </div>

                    )}
                    className="table-subscript table-subscript__discount"
                  />
                )}
              </Fragment>
              {record?.lineDiscountType !== 'Percent' && record?.showUnitDiscount && (
                <div className="small-add-button__blue small-add-button__blue-wrapper">
                  <FontAwesomeIcon icon={faTag} />
                  &nbsp;
                  <div className="doc-line__unit-discount">
                    <H3FormInput
                      value={record.unitDiscount}
                      type="number"
                      containerClassName="orgInputContainer"
                      labelClassName="orgFormLabel"
                      inputClassName="orgFormInput"
                      onChange={(e) => {
                        const copyData = JSON.parse(JSON.stringify(data));
                        const unitDiscountValue = Number.parseFloat(e.target.value) || 0;
                        const discountValue = Number.parseFloat(Number(Number(unitDiscountValue) * Number(record?.quantity)).toFixed(DEFAULT_CUR_ROUND_OFF));
                        const taxableValue = record?.lineDiscountType === 'Percent'
                          ? (record.quantity * record.unitPrice) * (1 - discountValue / 100)
                          : Math.max(record.quantity * record.unitPrice - discountValue, 0);

                        copyData.map((item) => {
                          if (item.key === record.key) {
                            item.discount = discountValue;
                            item.unitDiscount = unitDiscountValue || '';
                            item.child_taxes = Helpers.computeTaxation(taxableValue, record.taxInfo, billFromState, billToState)?.tax_info?.child_taxes;
                          }
                          return data;
                        });
                        updateData(copyData);
                      }}
                      disabled={!isLineWiseDiscount}
                    />
                    <H3Text text="/unit" className="doc-line__unit-discount-label" />
                    <FontAwesomeIcon
                      icon={faClose}
                      className="doc-line__unit-discount-close"
                      onClick={() => {
                        const copyData = JSON.parse(JSON.stringify(data));
                        copyData.map((item) => {
                          if (item.key === record.key) {
                            item.showUnitDiscount = !record?.showUnitDiscount;
                          }
                          return data;
                        });
                        updateData(copyData);
                      }}
                    />
                  </div>
                </div>
              )}
            </Fragment>
          );
        },
        hidden: isReturnSlip,
        visible: visibleColumns?.DISCOUNT?.visible,
      },
      {
        title: 'Line Total',
        render: (text, record) => {

          const discountValue = Number(record.discount) || 0;
          const taxableValue = record?.lineDiscountType === 'Percent' ? (record.quantity * record.unitPrice) * (1 - discountValue / 100) : Math.max(record.quantity * record.unitPrice - discountValue, 0);

          return (
            <H3Text
              text={record.taxInfo
                ? MONEY(Helpers.computeTaxation(taxableValue, record.taxInfo, billFromState, billToState)?.taxed_value, selectedCurrencyName?.currency_code) : 0}
              hideText={isDataMaskingPolicyEnable && isHideSellingPrice}
              popOverMessage={'You don\'t have access to view line total'}
            />
          );
        },
        hidden: isReturnSlip,
        visible: visibleColumns?.LINE_TOTAL?.visible,
      },
      {
        title: '',
        fixed: 'right',
        render: (text, record) => (
          <Fragment>
            {data.length !== record.key && (
              <div className="update-so__delete-line-button" onClick={() => handleDelete(record.key)}>
                <CloseOutlined />
              </div>
            )}
          </Fragment>
        ),
        width: '40px',
        visible: true,
      },
    ];
    if (cfCreditNoteLine?.length) {
      columns.splice(4, 0, ...CustomFieldHelpers.renderCustomLineColumns(false, cfCreditNoteLine, visibleColumns, customLineInputChange, formSubmitted, '', '', '', '', '', '', '', isCarryForward));
    }

    return columns.filter((item) => item?.visible);
  };

  const getDataSource = (data) => JSON.parse(JSON.stringify(data));

  return (
    <Fragment>
      <Table
        title={title}
        bordered
        loading={loading}
        showHeader
        size="small"
        scroll={{ x: 'max-content' }}
        columns={getColumns()}
        dataSource={getDataSource(data)}
        pagination={false}
        expandable={{
          defaultExpandAllRows: true,
          rowExpandable: (record) => record?.product_batches?.length,
          expandedRowRender: (record) => (
            <BatchSelectorCN
              batches={record?.product_batches}
              uomInfo={record?.uom_info}
              productUomInfo={record?.product_sku_info?.uom_info}
              expiryDays={record?.product_sku_info?.expiry_days}
              itemsRow={record}
              data={getDataSource(data)}
              updateData={updateData}
              onToggleBatch={(batch, adjustmentRow) => toggleBatch(batch, adjustmentRow)}
              noCalculations
              creditNoteWithReturnedQyt={creditNoteWithReturnedQyt}
              fromCreditNote
              productInfo={record?.product_sku_info}
              isReturnSlip={isReturnSlip}
            />
          ),
        }}
      />
    </Fragment>
  );
};

const mapStateToProps = ({
  UserReducers, PurchaseOrderReducers, OfferReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  updateCustomPurchaseOrderLoading: PurchaseOrderReducers.updateCustomPurchaseOrderLoading,
  selectedPurchaseOrder: PurchaseOrderReducers.selectedPurchaseOrder,
  getOfferByTenantSkuLoading: OfferReducers.getOfferByTenantSkuLoading,
  priceMasking: UserReducers.priceMasking,
});

const mapDispatchToProps = () => ({});

CNLines.propTypes = {
  handleProductChangeValue: PropTypes.func,
  handleProductChange: PropTypes.func,
  handleDelete: PropTypes.func,
  updateData: PropTypes.func,
  data: PropTypes.any,
  formSubmitted: PropTypes.bool,
  isLineWiseDiscount: PropTypes.bool,
  loading: PropTypes.any,
  addNewRow: PropTypes.any,
  title: PropTypes.any,
  billFromState: PropTypes.any,
  billToState: PropTypes.any,
  selectedCurrencyName: PropTypes.any,
  MONEY: PropTypes.any,
  toggleBatch: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CNLines));
